module.exports = __webpack_public_path__ + "static/img/payzhi.b819897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payzhi.png
// module id = liJ8
// module chunks = 3